import { render, staticRenderFns } from "./externalGigiMulut.vue?vue&type=template&id=65c24c5e"
import script from "./externalGigiMulut.vue?vue&type=script&lang=js"
export * from "./externalGigiMulut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c24c5e')) {
      api.createRecord('65c24c5e', component.options)
    } else {
      api.reload('65c24c5e', component.options)
    }
    module.hot.accept("./externalGigiMulut.vue?vue&type=template&id=65c24c5e", function () {
      api.rerender('65c24c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/external/pelayanan/externalGigiMulut.vue"
export default component.exports